var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('span',[_vm._v(" "+_vm._s(_vm.numberFormatter(_vm.scope.row[_vm.scope.column.property], _vm.scope.$index))+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }